import React, {Fragment, useState} from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import {__} from 'js/tool/page/current';
import Button from 'react-bootstrap/Button';
import {AuthContext} from 'js/reusable/auth/authContext';
import {setTestId} from 'js/reusable/testing/setTestId';
import {LoginFunc, ValidationErrors} from 'js/reusable/auth/types';
import Spinner from 'js/reusable/loading';

type IProps = {
	loading: boolean;
	policy: boolean;
	validationErrors?: ValidationErrors | null;
	certEmail: string;
}

function LoginForm({loading, policy, validationErrors, certEmail}: IProps) {
	const [username, setUsername] = useState(certEmail);
	const [password, setPassword] = useState('');

	function changeUsername({target: {value}}: React.ChangeEvent<HTMLInputElement>) {
		setUsername(value);
	}

	function changePassword({target: {value}}: React.ChangeEvent<HTMLInputElement>) {
		setPassword(value);
	}

	function onLogin(login: LoginFunc) {
		return function (e: React.MouseEvent<HTMLElement>) {
			e.preventDefault();
			login({username, password, policy: policy || undefined});
		};
	}

	return (
		<Fragment>
			<Form.Row>
				<Form.Group as={Col}>
					<Form.Control
						value={username}
						onChange={changeUsername}
						placeholder={__('fb:username')}
						isInvalid={!!validationErrors && !!validationErrors.username}
						disabled={loading || !!(certEmail && certEmail.length > 0)}
						data-testid={setTestId('login-username')}
					/>

					<Form.Control.Feedback type="invalid">
						{__(validationErrors ? validationErrors.username : '')}
					</Form.Control.Feedback>
				</Form.Group>
			</Form.Row>

			<Form.Row>
				<Form.Group as={Col}>
					<Form.Control
						value={password}
						onChange={changePassword}
						placeholder={__('fb:password')}
						type="password"
						isInvalid={!!validationErrors && !!validationErrors.password}
						disabled={loading}
						data-testid={setTestId('login-password')}
					/>

					<Form.Control.Feedback type="invalid">
						{__(validationErrors ? validationErrors.password : '')}
					</Form.Control.Feedback>
				</Form.Group>
			</Form.Row>

			<Form.Row>
				<Col>
					<AuthContext.Consumer>
						{({login}) => (
							<Button
								onClick={onLogin(login)}
								disabled={
									loading ||
									!!validationErrors &&
									!!validationErrors.policy &&
									!policy
								}
								type="submit"
								data-testid={setTestId('login-confirm')}
							>
								{__('login:entrance entry')}
								{
									loading && <Spinner className="tw-ml-1"/>
								}
							</Button>
						)}
					</AuthContext.Consumer>
				</Col>
			</Form.Row>
		</Fragment>
	);
}

export default LoginForm;
